const config = {
    API_URL: 'https://backend.futureitacademy.in/api/v1',
    BASE_URL: 'https://backend.futureitacademy.in'
};

export default config;
